<template>
  <div class="list-wrap">
    <div class="title-wrap">
      <van-image
        :src="require('@/assets/images/benefit-left-star.png')"
        class="icon"
      />
      <div class="title">超值生活权益</div>
      <van-image
        :src="require('@/assets/images/benefit-right-star.png')"
        class="icon"
      />
    </div>
    <div class="list">
      <div class="list-item" v-for="item in benefitList" :key="item.title">
        <div class="list-content">
          <van-image :src="item.icon_url" class="img" />
          <div class="list-main">
            <div class="name">{{ item.title }}</div>
            <div class="desc">{{ item.subtitle }}</div>
          </div>
        </div>
        <div class="list-action" @click="handleDraw(item)">立即领取</div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  defineComponent,
  ref,
  onMounted,
  computed,
} from "@vue/composition-api";

import { useRouter, useStore } from "@/components/use/base";
import { getUserBenefit } from "@/apis/home";

const vm = Vue.prototype;

export default defineComponent({
  setup() {
    const router = useRouter();
    const store = useStore();

    const benefitList = ref([]);

    const isMember = computed(() => {
      return store.state.isMember;
    });

    const initData = async () => {
      if (!isMember.value) {
        vm.$toast("您还不是会员");
        return;
      }
      const { data } = await getUserBenefit({
        card_status:
          vm.$getConfigValue("USER_BENEFIT_STAT_CARD_LIST") || undefined,
      });
      benefitList.value = data.benefit_list;
    };

    const handleDraw = (item) => {
      router.push(`/benefitDetail?benefit_type=${item.type}`);
    };

    onMounted(async () => {
      await initData();
    });

    return {
      handleDraw,
      initData,
      benefitList,
    };
  },
});
</script>

<style scoped lang="less">
.list-wrap {
  margin-top: 16px;
}

.title-wrap {
  display: flex;
  justify-content: center;
  align-items: center;

  .title {
    font-weight: 600;
    font-size: 16px;
    color: #000000;
    line-height: 22px;
    margin: 0 9px;
  }
  .icon {
    height: 22px;
  }
}

.list {
  margin-top: 16px;

  .list-item {
    margin: 0 12px 12px 12px;
    height: 79px;
    background: #fef5f1;
    border-radius: 8px;
    box-sizing: border-box;
    padding: 12px 19px 12px 13px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .list-content {
      display: flex;
      align-items: center;

      .img {
        width: 55px;
        height: 55px;
        border-radius: 8px;
        display: block;
      }
      .list-main {
        margin-left: 11px;

        .name {
          font-weight: 600;
          font-size: 16px;
          color: #000000;
          line-height: 22px;
        }
        .desc {
          margin-top: 9px;
          font-weight: 400;
          font-size: 12px;
          color: #666666;
          line-height: 16px;
        }
      }
    }

    .list-action {
      width: 70px;
      height: 24px;
      background: linear-gradient(
        134deg,
        #483122 0%,
        rgba(18, 0, 0, 0.87) 100%
      );
      border-radius: 13px;

      font-weight: 500;
      font-size: 12px;
      color: #f0dbbc;
      line-height: 24px;
      text-align: center;
    }
  }
}
</style>
